import { BasicPermissionItem } from '../../PermissionItem'
import {
  CreateViewEditSoftRemoveRestore,
  Revert,
  Simple,
  Unlock,
} from '../../common'
import { FDCTracker } from '../../../cimsPage/instances/fdc'

const page = FDCTracker
const object = 'Field Design Change'

const fdc = CreateViewEditSoftRemoveRestore({
  page,
  object,
  view: '0650231B-DAC6-41C2-9642-57FF6C7500E6',
  create: '9FF948CD-3433-4987-903C-70D99114544A',
  edit: '691C4591-CFE9-4A4F-8E3F-0888AEF7B9DE',
  removeRestore: '1184DE7F-1524-4B0E-800C-8854FB8CD03B',
})

export const ViewFieldDesignChange = fdc.View
export const CreateFieldDesignChange = fdc.Create
export const EditFieldDesignChange = fdc.Edit
export const RemoveRestoreFieldDesignChange = fdc.RemoveRestore

export const EditFieldDesignChangeResolution = new BasicPermissionItem({
  id: 'D857FDE7-4586-49AD-8F05-BCCEBB664A0C',
  name: `Edit ${object} Resolution`,
  page,
  action: `edit the ${object.toLowerCase()} resolution. Users with Edit ${object} do not need this permission`,
  allowMixedCase: true,
})

export const RevertFieldDesignChange = Revert({
  id: 'FA987396-35BA-4AD5-8BA7-5FFB91111715',
  page,
  object,
})

export const UnlockFieldDesignChange = Unlock({
  id: '74EF6E10-C80E-4412-9C9F-F20A79915C35',
  page,
  object,
})

export const CommentOnFieldDesignChange = Simple({
  id: '02D65F90-A130-4B4E-811B-56CCC28DEEFD',
  action: 'Comment on',
  page,
  object,
})

export type FDCTrackerPermission =
  | typeof ViewFieldDesignChange
  | typeof CreateFieldDesignChange
  | typeof EditFieldDesignChange
  | typeof RemoveRestoreFieldDesignChange
  | typeof EditFieldDesignChangeResolution
  | typeof RevertFieldDesignChange
  | typeof UnlockFieldDesignChange
  | typeof CommentOnFieldDesignChange
